export class UsuarioWhatsApp {
  idGrupoUsuarioTelefono?: number;
  idGrupoTelefono?: number = -1;
  idUsuario?: number;
  telefonoGrupo?: string;
  ladaGrupo?: string;
  devicedWhatsapp?: string;
  idUsuarioUM?: number = -1;
  estatus?: number = -1;
  idEmpresaAfiliada?: number = -1;
  nombreEmpresa?: string = "";
  tokenAcceso_Meta?: string = "";
  identificadorNumero_Meta?: string = "";
  wabaId?: string = "";
  metaConexion?: number = 0;
  registrado?: number = 0;
  suscrito?: number = 0;
  verificado?: number = 0;
  adminLine?: number = 0;
  nombre?: string = "";
  bearer?: string = "";
  identificador?: number = 0;
  idProyecto?: number = -1;
  avatarEmpresa?: string = "";
  nombreLinea?: string = "";
  accesoProyectoLinea?: number = 0;
}
